/** Localized titles live in messages; paths stay stable for routing. */

export const capabilities = {
  softwareEngineering: {
    href: "/services/software-engineering",
    messageKey: "softwareEngineering",
  },
  itSupportRmm: {
    href: "/services/it-support-rmm",
    messageKey: "itSupportRmm",
  },
  aiEnablement: {
    href: "/services/ai-enablement",
    messageKey: "aiEnablement",
  },
} as const;

export type CapabilityKey = keyof typeof capabilities;
